import { render, staticRenderFns } from "./chooseResourceStore.vue?vue&type=template&id=74a16043&scoped=true"
import script from "./chooseResourceStore.vue?vue&type=script&lang=js"
export * from "./chooseResourceStore.vue?vue&type=script&lang=js"
import style0 from "./chooseResourceStore.vue?vue&type=style&index=0&id=74a16043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a16043",
  null
  
)

export default component.exports